import { useState, useEffect } from 'react';
import { EventsPage } from '../../pages/EventsPage';
import { EventsScheduleSection } from '../attendee-mobile/EventsScheduleSection';

function useMediaQuery(maxWidth: number): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(`(max-width: ${maxWidth - 1}px)`).matches);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${maxWidth - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [maxWidth]);

  return matches;
}

/**
 * MobileEventsWrapper — On mobile viewports (<768px), ALL roles see the same
 * vertical event tiles experience (EventsScheduleSection). On desktop, the
 * full EventsPage is rendered.
 */
export function MobileEventsWrapper() {
  const isMobile = useMediaQuery(768);

  if (isMobile) {
    return <EventsScheduleSection />;
  }

  return <EventsPage />;
}
